import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { StreetAddressViewModel } from '../StreetAddress';
import Invoice from '../Invoices/Invoice';
import LoadingPanel from '../LoadingPanel';
import LoadingButton from '../LoadingButton';
import { InvoiceData } from '../Invoices';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    accountId: string;
    billingPeriodId: string;
}>;

type State = {
    accountId: number;
    billingPeriodId: number;
    invoices: InvoiceData[];
    errors: AlertData[];
    warnings: AlertData[];
    isGenerated: boolean;
    isLoading: boolean;
}


type AlertData = {
    Message: string;
    Link: string;
}

export default class AccountInvoicePreview extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            accountId: 0,
            billingPeriodId: 0,
            invoices: [],
            errors: [],
            warnings: [],
            isGenerated: false,
            isLoading: false,
        };

        this.generate = this.generate.bind(this);
    }

    public render() {
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Invoice" />
            <div className="form-row py-2 d-print-none">
                <div className="col-auto ml-auto">
                    <button role="button" className="btn btn-primary" onClick={() => { window.print() }}>Print Invoice(s)</button>
                    &nbsp;
                    {this.state.invoices.length > 0 && this.state.errors.length === 0 && !this.state.isGenerated &&
                        <LoadingButton className="btn btn-success" onClick={() => confirm("Finalize Invoice?") && this.generate()} isLoading={this.state.isLoading}>Finalize Invoice</LoadingButton>
                    }
                </div>
            </div>
            {this.state.errors.map((error, index) => {
                return <div className="alert alert-danger d-print-none" key={index}>
                    {error.Message}&nbsp;
                    {error.Link && <Link to={error.Link} className="alert-link">Fix Here</Link>}
                </div>
            })}
            {this.state.warnings.map((warning, index) => {
                return <div className="alert alert-warning d-print-none" key={index}>
                    {warning.Message}&nbsp;
                    {warning.Link && <Link to={warning.Link} className="alert-link">Adjust Here</Link>}
                </div>
            })}
            {this.state.invoices.map((invoice, index) => {
                return <Invoice invoice={invoice} key={index} />
            })}
            {this.state.invoices.length === 0 && <h4 className="text-center">No Charges Found.</h4>}
        </React.Fragment>
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        let billingPeriodId = parseInt(this.props.match.params.billingPeriodId) || 0;
        this.requestInvoices(accountId, billingPeriodId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;
        let billingPeriodId = parseInt(this.props.match.params.billingPeriodId) || 0;

        if (this.state.invoices && (this.state.accountId != accountId || this.state.billingPeriodId != billingPeriodId)) {
            this.requestInvoices(accountId, billingPeriodId);
        }
    }

    public requestInvoices(accountId: number, billingPeriodId: number) {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            AccountID: accountId
        }
        if (data.FacilityID) {
            fetchApi(`api/Billing/AccountList/${billingPeriodId}`, data, 'POST')
                .then((data: { IsGenerated: boolean, Invoices: InvoiceData[], Errors: AlertData[], Warnings: AlertData[] }) => {
                    this.setState({ invoices: data.Invoices, errors: data.Errors, warnings: data.Warnings, accountId, billingPeriodId });
                });
        } else {
            this.setState({ errors: [{ Message: 'Please select a facility first, using the dropdown above.', Link: '' }]})
        }
    }

    private generate() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            AccountID: this.state.accountId
        }
        this.setState({ isLoading: true });
        fetchApi(`api/Billing/GenerateIndividual/${this.state.billingPeriodId}`, data, 'POST')
            .then(() => {
                this.props.history.push(`/accounts/${this.state.accountId}/invoices`);
             })
            .catch(() => { alert("Failed to finalize invoice.") });
    }
}
